import React, { useState } from 'react'
import { Card, Grid, Button, CircularProgress } from '@mui/material'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import { Link } from 'react-router-dom'
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx'
import useAuth from 'app/hooks/useAuth'
import { toast } from 'react-toastify'
import history from 'history.js'
import { PasswordRequirements, PasswordTextValidator } from 'app/components'

const useStyles = makeStyles(({ palette, ...theme }) => ({
  cardHolder: {
    background: '#1A2038',
  },
  card: {
    maxWidth: 800,
    width: '100%',
    borderRadius: 12,
    margin: '1rem',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  resendButton: {
    color: palette.primary.main,
    cursor: 'pointer',
    fontSize: '12px',
    float: 'right',
  },
}))

const ForgotPassword = () => {
  const [state, setState] = useState({})
  const classes = useStyles()
  const { forgotPassword, forgotPasswordSubmit, singOutGlobal } = useAuth()
  const [sent, setSent] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleChange = ({ target: { name, value } }) => {
    setState({
      ...state,
      [name]: value,
    })
  }

  let { email, password, code } = state

  const sendResetCode = async () => {
    await forgotPassword(state.email)
    setSent(true)
    toast.success('Confirmation code has been sent successfully.')
  }

  const handleFormSubmit = async (event) => {
    setLoading(true)
    try {
      if (!sent) {
        await sendResetCode()
      } else {
        await forgotPasswordSubmit(email, code, password)
        toast.success('Password has been reset successfully.')
        history.push('/signin')
        singOutGlobal()
      }
    } catch (error) {
      toast.error(error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      className={clsx(
        'flex justify-center items-center  min-h-full-screen',
        classes.cardHolder
      )}
    >
      <Card className={classes.card}>
        <Grid container>
          <Grid item lg={5} md={5} sm={5} xs={12}>
            <div className="p-8 flex justify-center items-center h-full">
              <img className="w-full" src="/assets/images/logo.svg" alt="" />
            </div>
          </Grid>
          <Grid item lg={7} md={7} sm={7} xs={12}>
            <div className="p-8 h-full bg-light-gray relative">
              <ValidatorForm onSubmit={handleFormSubmit}>
                <TextValidator
                  disabled={sent}
                  className="mb-6 w-full"
                  variant="outlined"
                  label="Email"
                  onChange={handleChange}
                  type="email"
                  name="email"
                  size="small"
                  value={email || ''}
                  validators={['required', 'isEmail']}
                  errorMessages={['Required', 'Invalid email']}
                />

                {sent && (
                  <>
                    <TextValidator
                      className="w-full"
                      variant="outlined"
                      label="Confirmation Code"
                      onChange={handleChange}
                      type="text"
                      name="code"
                      size="small"
                      value={code || ''}
                      validators={['required']}
                      errorMessages={['Required']}
                    />
                    <div
                      className={clsx(classes.resendButton, 'mb-2 mt-2')}
                      onClick={sendResetCode}
                    >
                      Resend confirmation code
                    </div>
                    <PasswordTextValidator
                      className="mb-2 w-full"
                      label="New Password"
                      onChange={handleChange}
                      name="password"
                      value={password || ''}
                    />
                    <PasswordRequirements password={password} />
                  </>
                )}
                <div className="flex items-center mt-4">
                  <div className="relative">
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={loading}
                      type="submit"
                    >
                      {sent ? 'Reset Password' : 'Forgot Password'}
                    </Button>
                    {loading && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </div>
                  <span className="ml-4 mr-2">or</span>
                  <Link to="/signin">
                    <Button className="capitalize">Sign in</Button>
                  </Link>
                </div>
              </ValidatorForm>
            </div>
          </Grid>
        </Grid>
      </Card>
    </div>
  )
}

export default ForgotPassword
